<template>
    <div>
        <div class="head_box">
            <img style="width: 66px;height: 17px;" src="./img/banke.png" />
            <div class="line"></div>
            <div class="title">帮助中心</div>
            <div class="around">
                <div class="serach" @click="goSerach">
                    <img src="../../assets/sousuoxiao@2x.png" />
                </div>
                <div class="cata" @click="catalogue" :style="{'background': (cataStutas ? '#F6F6FB':'#3974C6')}">
                    <img :src="cataStutas?require('../../assets/mulu@2x.png'):require('../../assets/guanbi@2x.png')" />
                    <span :style="{'color': (cataStutas ? '#3974C6':'#FFFFFF')}">目录</span>
                </div>
            </div>
        </div>
        <div class="con_box">
            <!-- <view style="width: 100%;overflow: hidden;" v-html="product.remark"></view> -->
            <div v-show="cataStutas" style="width: 100%;overflow: hidden;padding: 34px 24px;">
                <van-loading type="spinner" color="#1989fa" v-if="loadShow" style="text-align: center;" />
                <div v-for="(item,index) of contentJson.contentList" :key="index">
                    <div v-html="item.text" style="font-size: 14px;"></div>
                </div>
            </div>
            <!-- <div v-html="content" v-show="cataStutas" style="width: 100%;overflow: hidden;"></div> -->
            <catalogue-page v-show="!cataStutas" @conback="cataBack"></catalogue-page>
        </div>
    </div>

</template>
<script>
    import cataloguePage from './components/catalogue'
    import { getCategory, getDetail } from "@/api/helpCenter";
    export default {
        components: {
            cataloguePage
        },
        data() {
            return {
                loadShow: false,
                testA: "<p><img src=\"http://test.api.bankmartech.com/static/2022/1223/1436/1671777378142463a54c6222c35.jpg\" alt=\"\" data-href=\"\" style=\"\"/></p><p><span style=\"color: rgb(31, 31, 31); background-color: rgb(255, 255, 255);\">病情分析：</span><span style=\"color: rgb(31, 31, 31); background-color: rgb(255, 255, 255);\"><em>布洛芬</em></span><span style=\"color: rgb(31, 31, 31); background-color: rgb(255, 255, 255);\">是解热镇痛类药物，如果用于退热一般不能超过三天，用于止痛连续使用不能超过五天。用于退烧只是对症治疗，需要明确病因，针对病因治疗才能使体温恢复正常。用于止痛不能长时间使用，不良反应发生的风险和剂量的大小、使用时间的长短有直接关系，长时间大剂量使用会表现出严重的胃肠道疾病，甚至是</span><span style=\"color: rgb(31, 31, 31); background-color: rgb(255, 255, 255);\"><em>上消化道出血</em></span><span style=\"color: rgb(31, 31, 31); background-color: rgb(255, 255, 255);\">，对肝肾的损伤也比较大。</span></p><p><img src=\"http://test.api.bankmartech.com/static/2022/1223/1436/1671777406937063a54c7ee4c45.jpg\" alt=\"\" data-href=\"\" style=\"\"/></p><p><span style=\"color: rgb(31, 31, 31); background-color: rgb(255, 255, 255);\">病情分析：</span><span style=\"color: rgb(31, 31, 31); background-color: rgb(255, 255, 255);\"><em>布洛芬</em></span><span style=\"color: rgb(31, 31, 31); background-color: rgb(255, 255, 255);\">是解热镇痛类药物，如果用于退热一般不能超过三天，用于止痛连续使用不能超过五天。用于退烧只是对症治疗，需要明确病因，针对病因治疗才能使体温恢复正常。用于止痛不能长时间使用，不良反应发生的风险和剂量的大小、使用时间的长短有直接关系，长时间大剂量使用会表现出严重的胃肠道疾病，甚至是</span><span style=\"color: rgb(31, 31, 31); background-color: rgb(255, 255, 255);\"><em>上消化道出血</em></span><span style=\"color: rgb(31, 31, 31); background-color: rgb(255, 255, 255);\">，对肝肾的损伤也比较大。</span></p>",
                cataStutas: true,
                contentJson: {},
                content: '',//富文本内容
                queryParams: {},
            }
        },
        created() {
            if (localStorage.getItem("eventCategory")) {
                this.queryParams = {
                    helpCategoryId: localStorage.getItem("eventCategory")
                }
                localStorage.removeItem("eventCategory");
                this.getDetailData()
            } else {
                this.getData()
            }

        },
        methods: {
            //前往搜索页面
            goSerach() {
                this.$router.push('/helpCenter/search')
            },
            //打开目录页面
            catalogue() {
                this.cataStutas = !this.cataStutas;
            },
            //获取分类
            getData() {
                getCategory().then((item) => {
                    //根据分类第一个ID查内容
                    this.queryParams = {
                        helpCategoryId: item.data[0].id
                    }
                    this.getDetailData()
                })
            },
            //获取内容
            getDetailData() {
                this.loadShow = true
                getDetail(this.queryParams).then((res) => {
                    if (res.code == 200) {
                        this.contentJson = res.data
                        this.loadShow = false
                    }
                })
            },
            //子组件传递事件
            cataBack(data) {
                this.contentJson = {}
                this.loadShow = true
                this.cataStutas = true
                setTimeout(() => {
                    this.contentJson = data
                    this.loadShow = false
                }, 1500);


            }
        }
    }
</script>

<style lang="less" scoped>
    ::v-deep img {
        max-width: 100%;
    }

    .head_box {
        width: 100%;
        height: 100%;
        display: inline-flex;
        align-items: center;
        position: relative;
        padding: 21px 20px;
        box-shadow: 0px 4px 10px 0px #f0f2f5;

        .line {
            width: 1px;
            margin-left: 8px;
            height: 13px;
            border: 1px solid #D8D8D8;
        }

        .title {
            margin-left: 14px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1B2751;
        }

        .around {
            position: absolute;
            right: 20px;
            display: inline-flex;

            .serach {
                width: 30px;
                height: 30px;
                background: #F6F6FB;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 14px;
                    height: 14px;
                }
            }

            .cata {
                margin-left: 11px;
                width: 72px;
                height: 30px;
                background: #F6F6FB;
                border-radius: 15px;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 16px;
                    height: 13px;
                }

                span {
                    margin-left: 2px;
                    font-size: 15px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #3974C6;
                }
            }
        }
    }

    .con_box {
        width: 100%;
        height: 100%;
        background: #FFFFFF;
    }
</style>